import { Store } from 'pullstate';

const ConfigStore = new Store({
  intlPrefix: '',
  localProfileElements: {},
  activeProfileElements: [],
  profileElements: [],
  marketingReferrers: [],
  currentPage: 'registration',
});

export default ConfigStore;
